<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Karte iz aplikacije ({{ totalRecords }}) ({{ totalPrice }} EUR)</h3>
                    </template>
                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" format="dd.MM.yyyy. HH:mm:ss"
                                    value-format="timestamp" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Tip</h4>
                            <base-input>
                                <el-select v-model="filter.ticketType" class="select-primary" name="ticketType" clearable
                                    @clear="filter.ticketType = null">
                                    <el-option v-for="t in ticketTypes" class="select-primary" :label="t.name"
                                        :value="t.id" :key="t.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Zona</h4>
                            <base-input>
                                <el-select v-model="filter.clientId" class="select-primary" name="zone" clearable
                                    @clear="filter.clientId = null">
                                    <el-option v-for="zone in zones" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Fiskalni status</h4>
                            <base-input>
                                <el-select v-model="filter.fiscalStatus" class="select-primary" name="fiscalStatus" clearable
                                    @clear="filter.fiscalStatus = null">
                                    <el-option v-for="fs in fiscalStatuses" class="select-primary" :label="fs.name"
                                        :value="fs.id" :key="fs.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="page = 1; getTickets()">Pretraži</base-button>
                        </div>
                        <base-button class="mt-3" type="info" @click="getReport()">Izveštaj</base-button>
                    </div>

                    <el-table :data="tickets" v-loading="ticketsLoading">
                        <el-table-column min-width="130" prop="stamp" label="Datum">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90" prop="client" label="Zona">
                            <template slot-scope="scope">
                                <span>{{ scope.row.client && scope.row.client.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="plates" label="Tablice">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="70" prop="price" label="Cena">
                            <template slot-scope="scope">
                                <span>{{ scope.row.price }} EUR</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90" prop="count" label="Količina (Sati/Dani)">
                            <template slot-scope="scope">
                                <span>{{ scope.row.count }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" label="Tip">
                            <template slot-scope="scope">
                                <span v-if="scope.row.day" style="color: aqua;">DNEVNA KARTA</span>
                                <span v-else style="color: cadetblue;">OBIČNA KARTA</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" label="Račun">
                            <template slot-scope="scope">
                                <span v-if="scope.row.fiscalNo" style="color: #00e676;">{{ scope.row.fiscalNo }}</span>
                                <span v-else style="color: #888;">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="140" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <base-button v-if="!scope.row.journal" :type="'warning'" class="btn-link"
                                    @click="fiscalizeTicket(scope.row)">
                                    Fiskalizuj
                                </base-button>
                                <base-button v-if="scope.row.journal" :type="'info'" class="btn-link"
                                    @click="openReceipt(scope.row)">
                                    Račun
                                </base-button>
                                <base-button :type="'success'" class="btn-link" @click="getTicket(scope.row)">
                                    Detalji
                                </base-button>
                            </div>
                        </el-table-column>
                    </el-table>

                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span><br>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <!-- Detalji karte -->
        <modal :show.sync="showTicket" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicket = false; ticket = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <div class="row">
                <div class="col-md-12">
                    <card>
                        Tablice: {{ ticket.plates }}<br>
                        <template v-if="ticket.plateParking">
                            Broj karte: {{ ticket.plateParking.ticketNumber }}<br>
                            Važi do: {{ (new Date(ticket.plateParking.stampEndLong)).toLocaleString("de-DE") }}<br>
                        </template>
                        Uplaćeno: {{ (new Date(ticket.stampLong)).toLocaleString("de-DE") }}&nbsp;&nbsp;&nbsp;<br>
                        Zona: {{ ticket.client && ticket.client.name }}<br>
                        Cena: {{ ticket.price }} EUR<br>
                        <span v-if="ticket.day" style="color: aqua;">DNEVNA KARTA</span>
                        <span v-else style="color: cadetblue;">OBIČNA KARTA</span>
                        <template v-if="ticket.fiscalNo">
                            <br><br>
                            Račun: {{ ticket.fiscalNo }}<br>
                            IKOF: {{ ticket.ikof }}<br>
                            JIKR: {{ ticket.jikr }}<br>
                        </template>
                    </card>
                </div>
            </div>
        </modal>

        <!-- Fiskalni racun (poseban overlay, ne modal - zbog scrola) -->
        <div v-if="showReceipt" class="receipt-overlay" @click.self="closeReceipt">
            <div class="receipt-paper">
                <div class="receipt-close" @click="closeReceipt">
                    <i class="tim-icons icon-simple-remove"></i>
                </div>
                <pre class="receipt-pre">{{ receiptText }}</pre>
                <div v-if="receipt.qrCode" class="receipt-qr-wrap">
                    <img :src="qrImageUrl" alt="QR" class="receipt-qr">
                    <a :href="receipt.qrCode" target="_blank" class="receipt-link">Provjeri račun</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { Table, TableColumn, TimeSelect, DatePicker, Select, Option } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb, BasePagination } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

const ticketTypes = [
    { id: 0, name: 'DNEVNA KARTA' },
    { id: 1, name: 'OBIČNA KARTA' }
]

const fiscalStatuses = [
    { id: 1, name: 'Fiskalizovano' },
    { id: 0, name: 'Nefiskalizovano' }
]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Option.name]: Option,
        [Select.name]: Select,
        BasePagination,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getUserPageFilter()
        this.getZones()
    },
    data() {
        const now = new Date();
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            ticketTypes,
            fiscalStatuses,
            url: 'https://budva.scancar.org:8443/kuca',
            fileUrl: 'https://budva.scancar.org:8443',
            ticketsLoading: false,
            loading: false,
            tickets: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp,
                plates: null,
                clientId: null,
                ticketType: null
            },
            zones: [],
            ticket: {},
            showTicket: false,
            receipt: {},
            showReceipt: false,
            page: 1,
            max: 10,
            totalRecords: 0,
            totalPages: 0,
            totalPrice: 0,
            fiscalStatus: null
        };
    },
    computed: {
        receiptText() {
            if (!this.receipt.journal) {
                return '';
            }
            // izbacimo {{qrCode}} placeholder, QR se renderuje kao slika ispod
            return this.receipt.journal.replace('{{qrCode}}', '').replace(/\s+$/, '');
        },
        qrImageUrl() {
            if (!this.receipt.qrCode) {
                return '';
            }
            return 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=' + encodeURIComponent(this.receipt.qrCode);
        }
    },
    methods: {
        getReport() {
            this.loading = true
            const f = this.filter
            axios.post(this.url + '/appTickets/getAppReport', f).then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    if (result.data.fileName) {
                        const link = document.createElement('a');
                        link.href = this.fileUrl + "/opomene/" + result.data.fileName;
                        link.download = "";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            }).catch(() => {
                this.loading = false
            })
        },
        fiscalizeTicket(row) {
            const swalConfirm = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalConfirm.fire({
                title: "Fiskalizovati kartu?",
                text: row.plates + " - " + row.price + " EUR",
                confirmButtonText: "Da, fiskalizuj",
                cancelButtonText: "Otkaži",
                showCancelButton: true,
            }).then((result) => {
                if (!result.value) {
                    return
                }
                this.loading = true
                axios.post(this.url + '/appTickets/fiscalizeTicket', { ticketId: row.id }).then(res => {
                    this.loading = false
                    if (res.data.result === 'ok') {
                        this.$notify({
                            message: 'Fiskalizovano, račun ' + res.data.invoiceNumber,
                            timeout: 3000,
                            icon: 'tim-icons icon-check-2',
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: 'success'
                        });
                        this.getTickets()
                    } else {
                        this.$notify({
                            message: res.data.reason,
                            timeout: 4000,
                            icon: 'tim-icons icon-bell-55',
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: 'danger'
                        });
                    }
                }).catch(() => {
                    this.loading = false
                })
            });
        },
        changeP(item) {
            this.page = item
            this.getTickets()
        },
        getUserPageFilter() {
            this.loading = true
            axios.get(this.url + '/settings/getUserPageFilter?page=20').then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    this.filter = result.data.filter
                }
                this.getTickets()
            }).catch(() => {
                this.loading = false
                this.getTickets()
            })
        },
        getZones() {
            axios.get(this.url + '/client/getClients').then(result => {
                if (result.data.result === 'ok') {
                    this.zones = result.data.clients
                }
            })
        },
        getTickets() {
            this.loading = true
            const f = this.filter
            f.page = this.page
            f.max = this.max
            axios.post(this.url + '/appTickets/getAppTickets', f).then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    this.tickets = result.data.tickets
                    this.totalPages = result.data.totalPages
                    this.totalRecords = result.data.totalRecords
                    this.totalPrice = result.data.totalPrice
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            }).catch(() => {
                this.loading = false
            })
        },
        getTicket(t) {
            this.ticket = t
            this.showTicket = true
        },
        openReceipt(t) {
            this.receipt = t
            this.showReceipt = true
        },
        closeReceipt() {
            this.showReceipt = false
            this.receipt = {}
        }
    }
};
</script>
<style lang="scss">
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    color: #ffffff;
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

.custom-modal-body {
    padding: 20px;
}

.receipt-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 100000;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
    padding: 30px 15px;
}

.receipt-paper {
    position: relative;
    background-color: #ffffff;
    color: #000000;
    border-radius: 6px;
    padding: 24px;
    width: 360px;
    max-width: 100%;
    margin: auto;
}

.receipt-close {
    position: absolute;
    top: 8px;
    right: 10px;
    cursor: pointer;
    color: #c0392b;
    font-size: 18px;
}

.receipt-pre {
    font-family: 'Courier New', Courier, monospace;
    font-size: 13px;
    line-height: 1.25;
    color: #000000;
    background: transparent;
    margin: 0;
    padding: 0;
    white-space: pre;
    overflow-x: auto;
}

.receipt-qr-wrap {
    margin-top: 12px;
    text-align: left;
}

.receipt-qr {
    display: block;
    width: 220px;
    height: 220px;
}

.receipt-link {
    display: inline-block;
    margin-top: 10px;
    color: #1a73e8;
    word-break: break-all;
}

.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

.loader {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>